import { useContext } from 'react';
import { AxiosContext } from '../providers/axios-provider';

export function useAxios() {
  return useContext(AxiosContext)!;
}
